import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate, useParams } from 'react-router-dom'

import FormTitle from '@components/text/formTitle'
import SimpleList from '@components/list/simpleList'
import SecondaryButton from '@components/inputs/button/secondaryButton'
import Loading from '@components/loading'
import colors from '@settings/styleSettings'

import { getDateFromStringDate, getDateFromFormattedDate } from '@util/timeUtil'

import {
  clearBeneficiary as clearBeneficiaryAction,
} from '@actions/beneficiary'

import {
  Container,
  TitleContainer,
  ItemContainer,
  ContentItem,
  Text,
  ButtonContainer,
  LoadingContainer,
} from './styles'

const renderCollectionItem = (item, navigate, insurance, beneficiaryId, clearBeneficiary) => {
  const onClickToCollectionById = () => {
    clearBeneficiary()
    navigate(`/${insurance}/beneficiario/${beneficiaryId}/${item.id}`)
  }

  return (
    <ItemContainer>
      <ContentItem>
        <Text>Coleta </Text>
        <Text>{getDateFromStringDate(item.collectedAt)}</Text>
      </ContentItem>
      <ButtonContainer>
        <SecondaryButton onClick={() => onClickToCollectionById(item.id)}>
          Ver relatório
        </SecondaryButton>
      </ButtonContainer>
    </ItemContainer>
  )
}

const sortCollectionsByDate = (collections) => {
  const sortedCollections = collections.sort((a, b) => {
    const dateA = getDateFromFormattedDate(a.collectedAt)
    const dateB = getDateFromFormattedDate(b.collectedAt)
    return dateB - dateA
  })
  return sortedCollections
}

const CollectionsHistoryModal = ({
  collections,
  isOpen,
  setClose,
  beneficiaryId,
  isLoading,
  clearBeneficiary,
}) => {
  const navigate = useNavigate()
  const { insurance } = useParams()

  return (
    <Container isOpen={isOpen}>
      <TitleContainer>
        <FormTitle title="Histórico de coletas" onClickGoBack={setClose} />
      </TitleContainer>

      {isLoading ? (
        <LoadingContainer>
          <Loading color={colors.primary} height={40} width={40} />
        </LoadingContainer>
      ) : (
        <SimpleList
          data={sortCollectionsByDate(collections)}
          renderItem={
            ({ item }) => renderCollectionItem(
              item,
              navigate,
              insurance,
              beneficiaryId,
              clearBeneficiary
            )
          }
        />
      )}
    </Container>
  )
}

CollectionsHistoryModal.propTypes = {
  setClose: PropTypes.func,
  isOpen: PropTypes.bool,
  collections: PropTypes.arrayOf(PropTypes.shape([])),
  beneficiaryId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  clearBeneficiary: PropTypes.func.isRequired,
}

CollectionsHistoryModal.defaultProps = {
  setClose: () => {},
  isOpen: false,
  collections: [],
}
const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    clearBeneficiary: clearBeneficiaryAction,
  },
  dispatch,
)

export default connect(null, mapDispatchToProps)(CollectionsHistoryModal)
